<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md12>
        <v-card color="white">
          <v-card-title primary class="title grey ">
            <span><v-icon large color="white">location_on</v-icon></span>{{contactNavTitle}}
          </v-card-title>
          <v-card-text>
            <div>
        <v-alert
          v-if="!loading && message.length > 0"
          v-model="alert"
          dismissible
          type="success"
        >
          {{message}}
        </v-alert>
        <v-progress-linear v-show="loading" :indeterminate="true"></v-progress-linear>
        <v-form v-show="!loading" ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="name"
              :rules="nameRules"
              :counter="3"
              label="Name"
              required
            ></v-text-field>
            <v-text-field
              :mask="mask"
              v-model="phone"
              :rules="phoneRules"
              :label="phoneLan"
              required
            ></v-text-field>
            <v-textarea
              :rules="messageRules"
              :label="messageLan"
              v-model="messageModel"
              :counter=250
            ></v-textarea>
            <v-btn
              :disabled="!valid"
              @click="submit"
            >
              {{submitLan}}
            </v-btn>
            <v-btn @click="clear">{{clearLan}}</v-btn>
        </v-form>
    </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data: () => ({
      alert: false,
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length >= 3) || 'Name must be longer than 2 characters'
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Phone is required',
        v => /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(v) || 'Phone must be valid'
      ],
      mask: 'phone',
      messageModel: '',
      messageRules: [
        v => !!v || 'Message is required',
        v => (v && v.length <= 250) || 'Message must be less than 250 characters'
      ],
    }),
    computed: {
        ...mapState('ContactModule', ['loading', 'message', 'phoneLan', 'messageLan', 
                                      'submitLan','clearLan',
                                      'warningFirst', 'warningSecond',
                                      'warningThird', 'warningFourth',
                                      'warningFifth', 'warningSixth', 'contactNavTitle']),
    },

    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          
          this.alert = true
          
          this.$store.dispatch('ContactModule/contactUs', {
                name: this.name,
                phone: this.phone,
                message: this.message
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>
